import MuiAppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import React, { ReactNode, useRef, useState } from 'react';

const PREFIX = 'AppBar';

const classes = {
  regular: `${PREFIX}-regular`,
  appBar: `${PREFIX}-appBar`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.regular}`]: {
    minHeight: '64px',
    '@media (min-width: 600px)': {
      minHeight: '64px'
    },
    '@media (min-width: 0px) and (orientation: landscape)': {
      minHeight: '64px'
    }
  },

  [`& .${classes.appBar}`]: {
    zIndex: theme.zIndex.drawer + 101
  }
}));

interface AppBarProps {
  children: ReactNode;
  show?: boolean;
}

const AnchorContext = React.createContext<React.MutableRefObject<null>>(
  {} as React.MutableRefObject<null>
);

export const useAnchor = () => React.useContext(AnchorContext);

// render an additional empty toolbar to prevent content to be hidden under the actual appbar

const AppBar = ({ children, show = true }: AppBarProps) => {
  const anchorEl = useRef(null);
  const [anchor] = useState(anchorEl);

  return (
    <Root style={{ display: show ? 'block' : 'none' }}>
      <MuiAppBar position="fixed" color="primary" className={classes.appBar}>
        <Toolbar
          ref={anchorEl}
          classes={{
            regular: classes.regular
          }}
        >
          <AnchorContext.Provider value={anchor}>{children}</AnchorContext.Provider>
        </Toolbar>
      </MuiAppBar>
      <Toolbar
        classes={{
          regular: classes.regular
        }}
      />
    </Root>
  );
};

export default AppBar;
